import { render, staticRenderFns } from "./SuperTable.vue?vue&type=template&id=557e871a&scoped=true&"
import script from "./SuperTable.vue?vue&type=script&lang=js&"
export * from "./SuperTable.vue?vue&type=script&lang=js&"
import style0 from "./SuperTable.vue?vue&type=style&index=0&id=557e871a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557e871a",
  null
  
)

export default component.exports